import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { AdminSidebar } from "@/components/sidebars";
import { apiClient } from "@/lib/api";

const fmtDate = (iso) => iso ? new Date(iso).toLocaleString("es-MX") : "—";

function ChangeDetail({ diff }) {
  if (!diff?.beneficiarios_changes?.length) return <small style={{ color: "#9ca3af" }}>—</small>;
  return (
    <div style={{ fontSize: 12 }}>
      {diff.beneficiarios_changes.map((c, i) => (
        <div key={i} style={{ marginBottom: 6, padding: 6, background: "#FAFBFD", borderRadius: 6 }}>
          <strong>{c.nombre || `Beneficiario #${c.idx}`}</strong> <span style={{ color: "#6b7280" }}>· {c.type}</span>
          {c.fields && Object.entries(c.fields).map(([field, vals]) => (
            <div key={field} style={{ marginLeft: 12, color: "#374151" }}>
              <code style={{ fontSize: 11 }}>{field}</code>:{" "}
              <span style={{ color: "#B91C1C" }}>{JSON.stringify(vals.from)}</span>
              {" → "}
              <span style={{ color: "#15803D" }}>{JSON.stringify(vals.to)}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default function AdminAudit() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get("/admin/audit?limit=200")
      .then(({ data }) => setEntries(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AppLayout sidebar={AdminSidebar}>
      <header className="app-header">
        <h1><i className="fas fa-shield-alt" style={{ color: "#163680", marginRight: 10 }} />Auditoría</h1>
        <p className="text-muted">Registro de cambios sensibles (datos médicos, membresías). Útil para compliance y trazabilidad.</p>
      </header>

      <div className="panel">
        {loading ? <p className="text-muted">Cargando…</p> : entries.length === 0 ? (
          <p className="text-muted">Sin entradas todavía. Aparecerán automáticamente cuando un usuario modifique datos sensibles.</p>
        ) : (
          <table className="data-table" data-testid="audit-table">
            <thead><tr><th>Fecha</th><th>Actor</th><th>Acción</th><th>Recurso</th><th>Cambios</th><th>IP</th></tr></thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id} data-testid={`audit-row-${e.id}`}>
                  <td><small>{fmtDate(e.timestamp)}</small></td>
                  <td><strong>{e.actor?.email}</strong><br /><small style={{ color: "#9ca3af" }}>{e.actor?.role}</small></td>
                  <td><span className="sol-pill sol-en_camino">{e.action}</span></td>
                  <td><small>{e.resource_type} · <code style={{ fontSize: 10 }}>{(e.resource_id || "").slice(0, 8)}</code></small></td>
                  <td><ChangeDetail diff={e.diff} /></td>
                  <td><small style={{ color: "#9ca3af" }}>{e.ip || "—"}</small></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AppLayout>
  );
}
